import { GroupStandingsTable } from '@/components/GroupStandingsTable';
import { useGroupStandings } from '@/hooks/useGroupStandings';
import { type Country } from '@/models/country';
import { getWorldCupGroupForCountry, groupTitleShort, worldCupGroups } from '@/models/wc26Groups';
import { TeamDetailSectionCard } from './TeamDetailSectionCard';

export function TeamDetailGroup(props: { country: Country }) {
  const groupStandings = useGroupStandings();
  const groupId = getWorldCupGroupForCountry(props.country);

  if (!groupId) {
    return null;
  }

  const teams = worldCupGroups[groupId];

  return (
    <TeamDetailSectionCard title={groupTitleShort(groupId)}>
      <GroupStandingsTable
        teams={teams}
        standings={groupStandings?.groups[groupId]}
        variant='modal'
      />
    </TeamDetailSectionCard>
  );
}
